import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { BookingStatsLineItem } from 'src/app/booking-stats-line-item';
import { SalesAgentTotalBookings } from './sales-agent-total-bookings';
import { SalesAgentWeeklyResult } from './sales-agent-weekly-result';
import { SalesReportResult } from './sales-report-result';
import { WeekRecord } from './week-record';
import { SalesReportRecordThisYear } from './sales-report-record-this-year';

@Injectable({
  providedIn: 'root'
})
export class SalesReportService {

  weekRecordList: WeekRecord[] = [];
  numberRecordList: WeekRecord[] = [];
  durationRecordList: WeekRecord[] = [];
  thisYear = moment().year();
  lastYear = moment().subtract(1, "year").year();
  twoYearsAgo = moment().subtract(2, "year").year();
  lineItems: BookingStatsLineItem[] = [];
  data: any;
  result: SalesReportResult | null = null;
  weekNums: number[] = [];
  lastWeekResultOfThisYear = 0;
  lastWeekResultOfLastYear = 0;
  thisWeekNum = 0;
  lastWeekNum = 0;
  mondayOfThisWeek: string | null = null;
  cumulativeWeeklyDataSet: SalesReportRecordThisYear[] = [];
  lastWeekDataSet = [];
  salesAgentTotals: SalesAgentTotalBookings[] = [];
  salesAgentsWeeklyResult: SalesAgentWeeklyResult[] = [];
  selectedChartOption: number = 1;

  constructor() { }

  setThisYearData(thisYearData: number[]){
    this.data.datasets[0] = thisYearData;
  }

  setCumulativeBookingData(dataOfThisYear: number[], dataOfLastYear: number[]){
    let thisYearDataset = this.data.datasets[0];
    let lastYearDataset = this.data.datasets[1];
    let weekCounter = 1;
    let weekNums: number[] = [];
    thisYearDataset.data = [];
    lastYearDataset.data = [];
    for(let num of dataOfThisYear){
      weekNums.push(weekCounter);
      weekCounter++;
      thisYearDataset.data.push(num);
    }
    for(let num of dataOfLastYear){
      lastYearDataset.data.push(num);
    }
  }
}
